module.exports = __webpack_public_path__ + "img/hosp-2.1a6dd6a9.jpg";